export default {
  setIsLoading(state, { isLoading }) {
    state.isLoading = isLoading;
  },

  setIsAnnouncement(state, isAnnouncement = false) {
    state.routeLayout.isAnnouncement = isAnnouncement;
  },

  setIsExcel(state, { isExcel }) {
    state.routeLayout.isExcel = isExcel;
  },

  setIsBack(state, { isBack }) {
    state.routeLayout.isBack = isBack;
  },
  setProductBuyMove(state, productBuyMove = false) {
    state.productBuyMove = productBuyMove;
  },

  setIsHome(state, { isHome }) {
    state.routeLayout.isHome = isHome;
  },
  setInitMovePath(state, initMovePath = '') {
    state.initMovePath = initMovePath;
  },
  setLoginMovePath(state, loginMovePath = '') {
    state.loginMovePath = loginMovePath;
  },
  setIsSmileShare(state, isSmileShare = false) {
    state.routeLayout.isSmileShare = isSmileShare;
  },

  setIsMemorialShare(state, isMemorialShare = false) {
    state.routeLayout.isMemorialShare = isMemorialShare;
  },

  setIsAnnouncementShare(state, isAnnouncementShare = false) {
    state.routeLayout.isAnnouncementShare = isAnnouncementShare;
  },

  setIsFuneralShare(state, isFuneralShare = false) {
    state.routeLayout.isFuneralShare = isFuneralShare;
  },

  setIsInvitationShare(state, isInvitationShare = false) {
    state.routeLayout.isInvitationShare = isInvitationShare;
  },

  setModalAlertComponents(state, { modalAlertComponents }) {
    state.modalAlertComponents = modalAlertComponents;
  },
  setModalComponents(state, { modalComponents }) {
    state.modalComponents = modalComponents;
  },
  setRouteLayout(
    state,
    {
      isHeader = undefined,
      isHeaderPrimary = undefined,
      titleName = undefined,
      isBack = undefined,
      isLike = undefined,
      isNav = undefined,
      isHome = undefined,
      isSearch = undefined,
      isGlass = undefined,
      isSearchHeader = undefined,
      isFilter = undefined,
      isShare = undefined,
      isFuneralShare = undefined,
      isFuneralKakaoShare = undefined,
      isAnnouncementShare = undefined,
      isAnnouncementKakaoShare = undefined,
      isSmileShare = undefined,
      isSmileKakaoShare = undefined,
      isInvitationShare = undefined,
      isInvitationKakaoShare = undefined,
      isBusinessLike = undefined,
      isBusinessSubscribe = undefined,
      isBusinessKakaoShare = undefined,
      isBusinessMarketingShare = undefined,
      isBusinessMarketingKakaoShare = undefined,
      isBusinessDonationShare = undefined,
      isBusinessDonationKakaoShare = undefined,
      isBusinessJobKakaoShare = undefined,
      isBusinessJobShare = undefined,
      isBusinessShare = undefined,
      isBizDetailShare = undefined,
      isMarketingShare = undefined,
      isMarketingKakaoShare = undefined,
      isMemorialShare = undefined,
      isMemorialKakaoShare = undefined,
      isExcel = undefined,
      subName = undefined,
      isBell = undefined,
      isSetting = undefined,
      isFooter = undefined,
      isPlus = undefined,
      isEdit = undefined,
      isDelete = undefined,
      isGreen = undefined
    }
  ) {
    state.routeLayout.isHeader = isHeader ?? false;
    state.routeLayout.isHeaderPrimary = isHeaderPrimary ?? false;
    state.routeLayout.titleName = titleName ?? false;
    state.routeLayout.isHome = isHome ?? false;
    state.routeLayout.isBack = isBack ?? false;
    state.routeLayout.isLike = isLike ?? false;
    state.routeLayout.isNav = isNav ?? false;
    state.routeLayout.isGlass = isGlass ?? false;
    state.routeLayout.isSearchHeader = isSearchHeader ?? false;
    state.routeLayout.isFilter = isFilter ?? false;
    state.routeLayout.isShare = isShare ?? false;
    state.routeLayout.isAnnouncementShare = isAnnouncementShare ?? false;
    state.routeLayout.isFuneralShare = isFuneralShare ?? false;
    state.routeLayout.isFuneralKakaoShare = isFuneralKakaoShare ?? false;
    state.routeLayout.isAnnouncementKakaoShare = isAnnouncementKakaoShare ?? false;

    state.routeLayout.isSmileShare = isSmileShare ?? false;
    state.routeLayout.isSmileKakaoShare = isSmileKakaoShare ?? false;
    state.routeLayout.isInvitationShare = isInvitationShare ?? false;
    state.routeLayout.isInvitationKakaoShare = isInvitationKakaoShare ?? false;

    state.routeLayout.isMemorialShare = isMemorialShare ?? false;
    state.routeLayout.isMemorialKakaoShare = isMemorialKakaoShare ?? false;
    state.routeLayout.isBusinessLike = isBusinessLike ?? false;
    state.routeLayout.isBusinessSubscribe = isBusinessSubscribe ?? false;
    state.routeLayout.isBusinessKakaoShare = isBusinessKakaoShare ?? false;
    state.routeLayout.isBusinessShare = isBusinessShare ?? false;
    state.routeLayout.isBizDetailShare = isBizDetailShare ?? false;
    state.routeLayout.isBusinessMarketingKakaoShare = isBusinessMarketingKakaoShare ?? false;
    state.routeLayout.isBusinessMarketingShare = isBusinessMarketingShare ?? false;
    state.routeLayout.isBusinessDonationShare = isBusinessDonationShare ?? false;
    state.routeLayout.isBusinessDonationKakaoShare = isBusinessDonationKakaoShare ?? false;
    state.routeLayout.isBusinessJobKakaoShare = isBusinessJobKakaoShare ?? false;
    state.routeLayout.isBusinessJobShare = isBusinessJobShare ?? false;
    state.routeLayout.isExcel = isExcel ?? false;
    state.routeLayout.subName = subName ?? '';
    state.routeLayout.isBell = isBell ?? false;
    state.routeLayout.isSetting = isSetting ?? false;
    state.routeLayout.isFooter = isFooter ?? false;
    state.routeLayout.isPlus = isPlus ?? false;
    state.routeLayout.isEdit = isEdit ?? false;
    state.routeLayout.isDelete = isDelete ?? false;
    state.routeLayout.isGreen = isGreen ?? false;

    if (!!isSearch) state.routeLayout.isSearch = isSearch;
  },
  setKeywords(state, { keywords = [] }) {
    state.keywords = JSON.stringify(keywords);
    localStorage.keywords = JSON.stringify(keywords);
  },
  memorizeScroll(state, scrolls = []) {
    state.scroll = scrolls;
  },
  appendScroll(state, scroll = {}) {
    state.scroll = [...state.scroll, scroll];
  },
  keepingAlive(state, keepAlive = []) {
    state.keepAlive = keepAlive;
  },
  setIsHeader(state, status) {
    state.routeLayout.isHeader = status;
  },
  setIsNav(state, isNav) {
    state.routeLayout.isNav = isNav;
  },
  setTitleName(state, titleName) {
    state.routeLayout.titleName = titleName;
  },
  setBottomSheet(state, bottomSheet = null) {
    state.bottomSheet = bottomSheet;
  },
  setIsFloating(state, isFloating = false) {
    state.isFloating = isFloating;
  },
  setIsHamburger(state, isHamburger = false) {
    state.isHamburger = isHamburger;
  },
  setIsWellFloating(state, isWellFloating = false) {
    state.isWellFloating = isWellFloating;
  },
  setIsBackFromSearch(state, isBackFromSearch) {
    state.isBackFromSearch = isBackFromSearch
  },
  setIsTodayExpireDate(state, isTodayExpireDate) {
    state.isTodayExpireDate = isTodayExpireDate
  },
  setIsIntroEnter(state, isIntroEnter) {
    state.isIntroEnter = isIntroEnter
  },
  setFormDirty(state, formDirty) {
    state.formDirty = formDirty
  },
  // 260609 리뉴얼: 메인 소비자/사업자 모드 토글. localStorage 영속.
  setHomeMode(state, homeMode) {
    state.homeMode = homeMode;
    try { localStorage.setItem('homeMode', homeMode); } catch (e) { /* storage 차단 환경 무시 */ }
  }
};
